module.exports = __webpack_public_path__ + "static/media/clock.412a5a79.svg";